import { UserSignupReducerState } from './UserSignupTypes';

class UserSignupStateDefinition {
  static getInitialState(): Partial<UserSignupReducerState> {
    return {};
  }
}

export default UserSignupStateDefinition;
